'use client'
import { jsx, jsxs } from "react/jsx-runtime";
import { Popover } from "@base-ui-components/react/popover";
import external_react_default, { useEffect, useState } from "react";
import { cn } from "../../utils/cn.js";
import { IconButton } from "../IconButton/index.js";
import external_ArrowSVG_js_default from "./ArrowSVG.js";
import { popoverVariants } from "./Popover.variants.js";
import { PopoverContent } from "./PopoverContent.js";
function Popover_Popover({ open = false, onOpenChange, defaultOpen, openOnHover = true, headingCustomNode, headingIconName, headingRightNode, align = 'center', triggerNode, headingText, children, side = 'bottom', ariaLabel, description, footer, showArrow = true, slotClassNames = {}, onClose, hideCloseButton = false, ...props }) {
    const triggerRef = external_react_default.useRef(null);
    const [isOpenState, setIsOpen] = useState(open);
    const noHeading = !headingText && !headingCustomNode;
    const { popupSlot, popupSlotAnimation, arrowSlot, headingSlot, headingCustomSlot, headingLeftSlot, headingRightSlot, headingCloseButtonSlot, headingTextSlot, headingIconSlot, backdropSlot, triggerSlot, bodySlot, bodyTextSlot, scrollAreaSlot, contentSlot, footerSlot } = popoverVariants({
        customHeader: !!headingCustomNode,
        customFooter: !!footer,
        customBody: !!children,
        noHeading,
        ...props
    });
    const { triggerClass = '', popupClass = '', backdropClass = '', scrollAreaClass = '', bodyClass = '', footerClass = '', contentClass = '', arrowClass = '', headingClass = '' } = slotClassNames;
    const triggerClasses = cn(triggerSlot(), triggerClass);
    const popupClasses = cn(popupSlot(), popupSlotAnimation(), popupClass);
    const backdropClasses = cn(backdropSlot(), backdropClass);
    const scrollAreaClasses = cn(scrollAreaSlot(), scrollAreaClass);
    const bodyClasses = cn(bodySlot(), bodyClass);
    const footerClasses = cn(footerSlot(), footerClass);
    const contentClasses = cn(contentSlot(), contentClass);
    const arrowClasses = cn(arrowSlot(), arrowClass);
    const headingClasses = cn(headingSlot(), headingClass);
    const renderCloseButton = ()=>/*#__PURE__*/ jsx(IconButton, {
            iconName: "close",
            type: "primary",
            shadow: true,
            size: "md",
            "aria-label": "Close popover",
            emphasis: "bold",
            onClick: handleClose
        });
    function handleClose(event) {
        setIsOpen(false);
        onClose?.();
        onOpenChange?.(false, event?.nativeEvent, void 0);
    }
    function handleOpenChange(open, event, reason) {
        setIsOpen(open);
        onOpenChange?.(open, event, reason);
    }
    useEffect(()=>{
        setIsOpen(open);
    }, [
        open
    ]);
    return /*#__PURE__*/ jsxs(Popover.Root, {
        open: isOpenState,
        defaultOpen: defaultOpen,
        openOnHover: openOnHover,
        onOpenChange: handleOpenChange,
        "data-testid": "root",
        children: [
            triggerNode ? /*#__PURE__*/ jsx(Popover.Trigger, {
                ref: triggerRef,
                className: triggerClasses,
                "data-testid": "trigger",
                children: triggerNode
            }) : null,
            /*#__PURE__*/ jsxs(Popover.Portal, {
                children: [
                    /*#__PURE__*/ jsx(Popover.Backdrop, {
                        className: backdropClasses
                    }),
                    /*#__PURE__*/ jsx(Popover.Positioner, {
                        sideOffset: 8,
                        align: align,
                        side: side,
                        children: /*#__PURE__*/ jsxs(Popover.Popup, {
                            finalFocus: triggerRef,
                            className: popupClasses,
                            "aria-label": ariaLabel,
                            children: [
                                showArrow ? /*#__PURE__*/ jsx(Popover.Arrow, {
                                    "data-testid": "arrowSvg",
                                    className: arrowClasses,
                                    children: /*#__PURE__*/ jsx(external_ArrowSVG_js_default, {
                                        ...props
                                    })
                                }) : null,
                                noHeading && !hideCloseButton ? /*#__PURE__*/ jsx("div", {
                                    "data-testid": "noHeadingCloseButton",
                                    className: headingCloseButtonSlot(),
                                    children: /*#__PURE__*/ jsx(Popover.Close, {
                                        render: ()=>/*#__PURE__*/ jsx("div", {
                                                children: renderCloseButton()
                                            })
                                    })
                                }) : null,
                                /*#__PURE__*/ jsx(PopoverContent, {
                                    headingCustomSlot: headingCustomSlot(),
                                    headingCloseButtonSlot: headingCloseButtonSlot(),
                                    headingLeftSlot: headingLeftSlot(),
                                    headingRightSlot: headingRightSlot(),
                                    headingTextSlot: headingTextSlot(),
                                    headingIconSlot: headingIconSlot(),
                                    bodyTextSlot: bodyTextSlot(),
                                    renderCloseButton: renderCloseButton,
                                    headingCustomNode: headingCustomNode,
                                    headingText: headingText,
                                    headingIconName: headingIconName,
                                    headingRightNode: headingRightNode,
                                    description: description,
                                    footer: footer,
                                    headingClasses: headingClasses,
                                    scrollAreaClasses: scrollAreaClasses,
                                    contentClasses: contentClasses,
                                    bodyClasses: bodyClasses,
                                    footerClasses: footerClasses,
                                    children: children
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
export { Popover_Popover as Popover };
